import React from "react";
import { CellProps } from "react-table";
import { ZonedDateTime } from "../../../../../../components/global_components/ZonedDateTime";
import { InspectionData } from "../constants/CitizenInspection";
import { InspectionStatus, InspectionStatuses } from "../constants/InspectionStatus";
import { Button } from "semantic-ui-react";

interface Props {
  cellProps: CellProps<InspectionData>;
  onRequestInspection: (id: string) => void;
}
export default function InspectionScheduledCell({ cellProps, onRequestInspection }: Props) {
  const attributes = cellProps.row.original.attributes;
  const status = attributes["status"] as InspectionStatus;

  const onRequestInspectionClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    onRequestInspection(cellProps.row.original.id);
  };

  if (status === InspectionStatuses.UNSCHEDULED) {
    return <UnscheduledInspectionScheduledCell onRequestInspection={onRequestInspectionClick} />;
  }

  if (status === InspectionStatuses.REQUESTED) {
    return <RequestedInspectionScheduledCell cellProps={cellProps} onRequestInspection={onRequestInspectionClick} />;
  }

  const scheduledAt = attributes["scheduled-at"];
  return <ZonedDateTime value={scheduledAt} />;
}

interface IRequestedInspectionScheduledCell {
  cellProps: CellProps<InspectionData>;
  onRequestInspection: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
function RequestedInspectionScheduledCell({ cellProps, onRequestInspection }: IRequestedInspectionScheduledCell) {
  const attributes = cellProps.row.original.attributes;

  const requestPreferences = attributes.request.preferences;
  if (requestPreferences.length === 0) {
    return <>No requested dates</>;
  }

  const firstRequestPreference = requestPreferences[0];
  const firstRequestedDay = firstRequestPreference.date ?? "";
  const firstRequestedMeridiem = firstRequestPreference.meridiem ?? "";

  return (
    <>
      <p className='italic tw-mb-0'>
        Requested{" "}
        {new Date(firstRequestedDay).toLocaleDateString(undefined, { month: "short", year: "numeric", day: "numeric" })}{" "}
        {firstRequestedMeridiem}
      </p>
      <Button
        onClick={onRequestInspection}
        className='tw-mt-1 tw-border-none tw-bg-transparent tw-px-0 tw-py-1 tw-text-blue focus:tw-ring-2 focus:tw-ring-blue focus:tw-ring-offset-2'
      >
        Change Requested Date
      </Button>
    </>
  );
}

interface IUnscheduledInspectionScheduledCell {
  onRequestInspection: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
function UnscheduledInspectionScheduledCell({ onRequestInspection }: IUnscheduledInspectionScheduledCell) {
  return (
    <Button primary onClick={onRequestInspection}>
      Request Inspection
    </Button>
  );
}
